"use client"
import { Box, Container, Stack } from "@mui/material";
import Helmet from "react-helmet";
import React from "react";
import {config} from '../config.js'

const navBarHeight = config.navbarHeight

export function PageFull({title, children, sx}) {
  return (
    <Box 
      sx={{
        display: 'flex', 
        justifyContent:'center', 
        alignItems: 'center',
        flexDirection: 'column',
        ...sx
      }}
    >
      <Helmet>
        <title>{title}</title>
      </Helmet>
        {children}
    </Box>
  )
}



export function PageContainer({title, children, sx}) {
  return (
    <Container 
      maxWidth='lg' 
      sx={{
        display: 'flex', 
        justifyContent:'center', 
        alignItems: 'center',
        width: '100%',
        flexDirection: 'column',
        paddingX: 3,
        ...sx
      }}
    >
      <Helmet>
        <title>{title}</title>
      </Helmet>
        {children}
    </Container>
  )
}